const noop = () => null;
export default {
  color: noop,
  spacingUnit: noop
};